const FormText = ({ children, className }) => {
  return (
    <div style={{ maxWidth: 450 }} className={className || undefined}>
      {children}
    </div>
  )
}

export default FormText
